/**
 * The built-in radiator (defs/radiator.ts) as a data spec: a body rectangle
 * filled with fin lines — a linear repeat whose spacing follows the
 * `finSpacing` param, stretched evenly to fill the run (last cell dropped:
 * the fins sit BETWEEN cells). Same drawing at every size and spacing.
 */

import { OBJECT_DEFINITION_SCHEMA_VERSION, type ObjectDefinitionSpec } from '../spec';

const W = 1.0;
const D = 0.1;
const HW = W / 2;
const HD = D / 2;
const SPACING = 0.06;

export const radiatorSpec: ObjectDefinitionSpec = {
  schemaVersion: OBJECT_DEFINITION_SCHEMA_VERSION,
  anchor: 'LINE',
  constraint: { kind: 'WALL', defaultInset: 0.03 },
  defaultSize: { width: W, depth: D, height: 0.6 },
  params: [{ key: 'finSpacing', kind: 'float', label: 'fin spacing', default: SPACING, min: 0.02, max: 0.3, decimals: 2, distance: true }],
  shapes: [
    { id: 'body', name: 'Body', kind: 'rect', min: [-HW, -HD], max: [HW, HD] },
    // One cell's fin, at the cell's end; the repeat drops the last one (the body's end).
    { id: 'fin', name: 'Fin', kind: 'polyline', points: [[-HW + SPACING, -HD], [-HW + SPACING, HD]], closed: false },
  ],
  groups: [
    {
      id: 'fins',
      name: 'Fins',
      shapeIds: ['fin'],
      resize: { u: 'stretch', n: 'stretch' },
      repeat: { kind: 'linear', axis: 'u', cell: [-HW, -HW + SPACING], pitch: { param: 'finSpacing' }, fit: 'fill', cellResize: 'stretch', skip: 'last', minCount: 1 },
    },
  ],
  model3d: null,
};
